/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Home_StagingInputs */

const cs_enum_home_staging = /** @type {(inputs: Enum_Home_StagingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Home staging`)
};

const en_enum_home_staging = /** @type {(inputs: Enum_Home_StagingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Home staging`)
};

/**
* | output |
* | --- |
* | "Home staging" |
*
* @param {Enum_Home_StagingInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_home_staging = /** @type {((inputs?: Enum_Home_StagingInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Home_StagingInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_home_staging(inputs)
	return cs_enum_home_staging(inputs)
});